import { useEffect } from 'react'
import { Logo } from '../branding/Logo'

interface Props {
  onComplete: () => void
}

export function SplashScreen({ onComplete }: Props) {
  useEffect(() => {
    const timer = setTimeout(onComplete, 2200)
    return () => clearTimeout(timer)
  }, [onComplete])

  return (
    <div className="fixed inset-0 bg-black flex flex-col items-center justify-center
                    overflow-hidden">
      {/* Animated background dots */}
      <div className="absolute inset-0 opacity-5">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full bg-white"
            style={{
              left: `${(i * 13 + 7) % 100}%`,
              top: `${(i * 17 + 5) % 100}%`,
              animationDelay: `${i * 0.1}s`,
            }}
          />
        ))}
      </div>

      {/* Logo area */}
      <div className="relative z-10 flex flex-col items-center gap-8 animate-fade-in">
        <Logo
          size={260}
          className="animate-scale-in w-[62vw] max-w-[300px] h-auto
                     drop-shadow-[0_0_40px_rgba(200,219,74,0.35)]"
        />

        {/* Loading indicator */}
        <div className="flex gap-1.5">
          {[0, 1, 2].map(i => (
            <div
              key={i}
              className="w-1.5 h-1.5 rounded-full bg-brand-lime animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
      </div>

    </div>
  )
}
